/* ── FAQ ── */
document.querySelectorAll('.faq-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var item = btn.closest('.faq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(function(i) {
      i.classList.remove('open');
      i.querySelector('.faq-btn').setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});

/* ── MOBIILI/DESKTOP TOGGLE ── */
function applyResponsiveLayout() {
  var isMobile = window.innerWidth < 600;
  var kelvinMobile = document.querySelector('.kelvin-mobile');
  var kelvinDesktop = document.querySelector('.kelvin-desktop');
  var tableMobile = document.querySelector('.usecase-mobile');
  var tableDesktop = document.querySelector('.usecase-desktop');
  if (kelvinMobile) kelvinMobile.style.display = isMobile ? 'block' : 'none';
  if (kelvinDesktop) kelvinDesktop.style.display = isMobile ? 'none' : 'block';
  if (tableMobile) tableMobile.style.display = isMobile ? 'flex' : 'none';
  if (tableDesktop) tableDesktop.style.display = isMobile ? 'none' : 'table';
}
applyResponsiveLayout();
window.addEventListener('resize', applyResponsiveLayout);

/* ── KELVIN EXPLORER ── */
var kelvinData = [
  { min:1800, max:2200, color:'#ff8c00', name:'Kynttilänvalo', desc:'Erittäin lämmin, kellertävä valo. Käytetään tunnelmavalaistuksessa, ei ajovaloissa.',
    tags:[{t:'Tunnelma',g:true},{t:'Ei ajovaloihin',g:false},{t:'Heijastuu vähiten',g:true}] },
  { min:2200, max:3000, color:'#ffaa33', name:'Lämmin valkoinen', desc:'Lämmin valkoinen valo. Käytetään mm. sumuvaloisssa. Heijastuu vähiten lumesta ja vesisateesta.',
    tags:[{t:'Sumuvalo',g:true},{t:'Talviajo',g:true},{t:'Miellyttävä silmälle',g:true}] },
  { min:3000, max:3800, color:'#ffcc66', name:'Neutraali lämmin', desc:'Lämmin neutraali sävy. Miellyttävä sisävalaistukseen, toimii myös ajoissa kun häikäisy on ongelma.',
    tags:[{t:'Miellyttävä',g:true},{t:'Sisätilat',g:true},{t:'Vähän heijastumista',g:true}] },
  { min:3800, max:4300, color:'#fff0b3', name:'Neutraali valkoinen', desc:'Alan uusi premium-suunta. 4000K korostaa maaston muotoja ja epätasaisuuksia erinomaisesti. Silmälle paras pitkässä käytössä.',
    tags:[{t:'Premium työvalo',g:true},{t:'Maaston muodot',g:true},{t:'Silmälle paras',g:true}] },
  { min:4300, max:5100, color:'#fffde8', name:'Päivänvalo — Premium-alue', desc:'Alan uusi premium-alue lisävaloissa. 4500K on nykytrendin suosituin arvo: erinomainen kontrasti, korostaa maaston muotoja, ei häikäise eikä heijastele. 5000K on nykystandardi, 5500K alkaa jo olla maksimi.',
    tags:[{t:'Lisävalot ★★ Premium',g:true},{t:'Työvalo',g:true},{t:'Paras kontrasti',g:true},{t:'Alan suositus',g:true}] },
  { min:5100, max:5800, color:'#f0f8ff', name:'Kirkas valkoinen — nykystandardi', desc:'5000–5700K on nykyisin lisävalojen yläraja. Toimii hyvin kuivalla tiellä, mutta alkaa heijastua sateessa ja lumessa.',
    tags:[{t:'Nykystandardi',g:true},{t:'Kuiva keli',g:true},{t:'Alkaa heijastua sateessa',g:false}] },
  { min:5800, max:6800, color:'#d8ecff', name:'Viileä valkoinen — vältä', desc:'Tämä alue on jäämässä pois ammattikäytöstä. Heijastuu voimakkaasti sateesta ja lumesta. Monet valmistajat luopuneet tästä alueesta.',
    tags:[{t:'Vanhentuva',g:false},{t:'Heijastuu sateessa',g:false},{t:'Ei suositella',g:false}] },
  { min:6800, max:10100, color:'#b0d0ff', name:'Sinertävä — ei ajovaloihin', desc:'Erittäin kylmä, sinertävä valo. Heijastuu voimakkaasti sateesta, lumesta ja sumusta. Ei suositella ajovaloihin tai lisävaloihin.',
    tags:[{t:'Ei ajovaloihin',g:false},{t:'Heijastuu voimakkaasti',g:false}] }
];

function updateExplorer(val) {
  var data = kelvinData.find(function(d) { return val >= d.min && val < d.max; })
    || kelvinData[kelvinData.length - 1];

  document.getElementById('ke-val').textContent = val;
  document.getElementById('ke-swatch').style.background = data.color;
  document.getElementById('ke-name').textContent = data.name;
  document.getElementById('ke-desc').textContent = data.desc;

  var tagsEl = document.getElementById('ke-tags');
  tagsEl.innerHTML = data.tags.map(function(t) {
    return '<span class="ke-tag' + (t.g ? ' good' : ' caution') + '">' + t.t + '</span>';
  }).join('');
}

var range = document.getElementById('ke-range');
if (range) {
  updateExplorer(parseInt(range.value));
  range.addEventListener('input', function() {
    updateExplorer(parseInt(this.value));
  });
}
